import { render, staticRenderFns } from "./ChoiceItem.vue?vue&type=template&id=45a74f0c&scoped=true&"
import script from "./ChoiceItem.vue?vue&type=script&lang=js&"
export * from "./ChoiceItem.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceItem.vue?vue&type=style&index=0&id=45a74f0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a74f0c",
  null
  
)

export default component.exports